import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
      background: 'linear-gradient(45deg, #b3c7e8 30%, #345d9e 90%)',
      border: 0,
      borderRadius: 3,
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      color: 'white',
      height: 48,
      padding: '0 30px',
      marginBottom: '50px'
    },
  });

const ExcelButton = () => {
    const classes = useStyles();
    return (
        <button type="button" className={classes.root}>дані .xlsx</button>
    );
}

export default ExcelButton;